import {Pipe, PipeTransform} from '@angular/core';
import {Moment} from '../helpers/core/moment/moment';

@Pipe({
    name: 'time'
})
export class TimePipe implements PipeTransform {

    transform(value: any, format?: string): any {
        if (!value) {
            return '';
        }
        if (!format) {
            format = 'hh:mm A';
        }
        return Moment.timeFormat(value, format);
    }

}
